( () => {
  const TARGET_SELECTOR = '.related-posts';

  // Only run if URL contains /page/
  if ( !window.location.pathname.includes( '/page/' ) ) return;

  const getOffset = () => {
    const adminBar = document.getElementById( 'wpadminbar' );
    const header = document.querySelector( 'header' );
    return ( header?.offsetHeight || 0 ) + ( adminBar?.offsetHeight || 0 );
  };

  const EXTRA_OFFSET = 50; // <--- added 50px

  const doScrollTo = ( el ) => {
    if ( !el ) return;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    const top =
      el.getBoundingClientRect().top +
      scrollY -
      getOffset() -
      EXTRA_OFFSET; // <--- apply extra 50px

    window.scrollTo( {
      top: Math.max( 0, top ),
      behavior: 'smooth',
    } );
  };

  const debounce = ( fn, wait = 180 ) => {
    let t;
    return ( ...args ) => {
      clearTimeout( t );
      t = setTimeout( () => fn( ...args ), wait );
    };
  };

  let userInitiated = false;
  let pendingTarget = null;

  const requestScroll = ( el ) => {
    userInitiated = true;
    pendingTarget = el || pendingTarget || document.querySelector( TARGET_SELECTOR );
    debouncedScroll();
  };

  const debouncedScroll = debounce( () => {
    if ( !userInitiated ) return;

    const el =
      ( pendingTarget && document.body.contains( pendingTarget ) && pendingTarget ) ||
      document.querySelector( TARGET_SELECTOR );

    doScrollTo( el );

    pendingTarget = null;
    userInitiated = false;
  }, 180 );

  document.addEventListener( 'DOMContentLoaded', () => {
    const target = document.querySelector( TARGET_SELECTOR );
    if ( target ) requestScroll( target );
  } );

} )();
